import styled, { SimpleInterpolation, css } from "styled-components";

export const CommonInputStyle = css<{
  width: string;
  height: string;
  background: string;
  backgroundHover?: string;
  color: string;
  placeholderColor: string;
}>`
  width: ${(p) => p.width || "230px"};
  height: ${(p) => p.height || "28px"};
  background: ${(p) => p.background || "#343538"};
  color: ${(p) => p.color || "#FFFFFF"};
  padding: ${(p) => p.padding || "0 8px"};
  border-radius: 2px;
  &::placeholder {
    color: ${(p) => p.placeholderColor || "#5C6569"};
  }
  &:hover {
    background: ${(p) => p.backgroundHover || p.background || "#18191d"};
    ${(p) =>
      p.focusBorderColor &&
      css`
        border: 1px solid ${(p) => p.focusBorderColor};
      `}
  }
`;

export const CommonInput = styled.input<{ customCSS?: SimpleInterpolation }>`
  all: unset;
  ${CommonInputStyle};
  ${(p) => p.customCSS};
`;

export const InputWrapper = styled.div<{
  focus?: boolean;
  background?: string;
  focusBorderColor?: string;
  borderColor?: string;
}>`
  all: unset;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  background: ${(p) => p.background || "#18191d"};
  border: 1px solid ${(p) => p.borderColor || "transparent"};
  ${CommonInputStyle};
  input {
    flex: 1;
    height: 100%;
  }
  &:hover {
    input {
      background: ${(p) => p.background || "#18191d"};
      border: none;
    }
  }
  ${(p) =>
    p.focus &&
    css`
      border: 1px solid ${(p) => p.focusBorderColor || "#13cb75"};
      background: ${(p) => p.background || "#18191d"};
      input {
        background: ${(p) => p.background || "#18191d"};
      }
    `}
`;

export const IconInputWrapper = styled(InputWrapper)`
  padding: 0 ${(p) => (p.suffix ? "8px" : "0")} 0
    ${(p) => (p.prefix ? "8px" : "0")};
  width: 100%;
  height: 100%;
`;
